var e={reset:"reset--Pkr9u"};export{e as default};
